import { useEffect, useState } from "react";
import {
  findScrollParent,
  measureScrollParentContentHeight,
} from "src-next/modules/clinical-insights/helpers/findScrollParent";

export function useScrollParentHeight(element: HTMLElement | null): number {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!element) return;

    const scrollParent = findScrollParent(element);
    const measure = () => {
      setHeight(measureScrollParentContentHeight(scrollParent));
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(scrollParent);
    window.addEventListener("resize", measure);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [element]);

  return height;
}
